// Pure JSONL parsing shared by the table/data components and the bulk analyzer.
// Kept React-free (the `*-core.ts` convention) so non-UI callers and tests can
// import it without pulling in the component tree.

export interface ParsedEntry {
  timestamp?: string;
  type?: string;
  operation?: string;
  message?: {
    content:
      | string
      | Array<{
          type: string;
          text?: string;
          name?: string;
          id?: string;
          tool_use_id?: string;
        }>;
  };
  subtype?: string;
  error?: string;
  [key: string]: unknown;
}

export function parseJsonl(text: string): ParsedEntry[] {
  return text
    .trim()
    .split("\n")
    .filter(Boolean)
    .flatMap((line) => {
      try {
        return [JSON.parse(line)];
      } catch {
        return [];
      }
    });
}
